import {
  Avatar,
  Divider,
  Flex,
  SimpleGrid,
  Text,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { ComponentNewCard, HeaderNewCard } from "../components";
import { IListProduct } from "../../../../interfaces/Products/IListProducts";
import { generateSlug } from "../../../../utils/cleanSlug";
import { useTranslation } from "react-i18next";
import { Profile, TickCircle } from "iconsax-react";
import { client_selected } from "../../../../client";
import InfoTrade from "../components/InfoTrade";

type IProps = {
  item: IListProduct;
  preSlug?: string;
  purchase?: boolean;
};

export default function NewCard({ item, preSlug, purchase }: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(
      !!preSlug
        ? `${preSlug}${generateSlug(item.title)}&id=${item.id.toString()}`
        : `${generateSlug(item.title)}&id=${item.id.toString()}`,
      {
        preventScrollReset: false,
      }
    );
  };
  const isCopyTrading = item?.category === "CopyTrading";
  const isGenial = client_selected.name === "Genial";
  return (
    <ComponentNewCard
      onClick={handleNavigate}
      image={item?.photo}
      title={item?.title}
    >
      <Flex
        direction={"row"}
        p={"10px"}
        gap="8px"
        justify={"space-between"}
        align={isGenial ? "start" : "center"}
        w="100%"
      >
        <HeaderNewCard item={item} />
        {isGenial ? (
          purchase ? (
            <Flex miw={{ base: "26px", 500: "43px" }}>
              <Tooltip label="Assinado">
                <TickCircle
                  size={43}
                  color={theme.colors.alerts[2]}
                  variant="Bold"
                />
              </Tooltip>
            </Flex>
          ) : null
        ) : null}
      </Flex>
      <Flex direction={"column"} gap="10px">
        <SimpleGrid
          spacing={10}
          breakpoints={[
            { minWidth: 200, cols: 2 },
            { minWidth: 400, cols: 4 },
          ]}
        >
          {isCopyTrading ? (
            <>
              <InfoTrade
                value={!!item?.release_date ? item?.release_date : "----"}
                label="marketplace.card.date_init"
              />
              <InfoTrade
                value={!!item?.profitability ? item?.profitability : "----"}
                label="marketplace.card.return_percent"
                color={
                  !!item?.profitability
                    ? item?.profitability.includes("-")
                      ? theme.colors.alerts[0]
                      : theme.colors.alerts[2]
                    : theme.colors.basic[2]
                }
              />
              <InfoTrade
                value={
                  !!item?.min_value_config ? item?.min_value_config : "----"
                }
                label="marketplace.card.min"
              />
              <InfoTrade
                value={!!item?.max_loss_daily ? item?.max_loss_daily : "----"}
                label="marketplace.card.max"
                color={theme.colors.alerts[0]}
              />
            </>
          ) : null}
        </SimpleGrid>
        <Divider
          style={{
            transition: "all 0.5s linear",
          }}
        />

        <Flex gap="10px" p="5px" h="76px">
          <Avatar
            variant="outline"
            size={40}
            color="basic.2"
            radius={4}
            src={item?.icon}
            alt={!!item?.title ? item.title : "--"}
            styles={{
              root: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1.5px solid ${theme.colors.basic[2]}`,
              },
              image: {
                height: "40px",
                width: "40px",
              },
            }}
          >
            <Profile color={theme.colors.basic[5]} />
          </Avatar>
          <Text
            fw={400}
            size={14}
            lh="155%"
            color="white"
            lineClamp={3}
            h="66px"
          >
            {!!item?.short_description
              ? item.short_description
              : t("marketplace.card.n_a")}
          </Text>
        </Flex>
      </Flex>
    </ComponentNewCard>
  );
}
